import React, { useEffect, useRef, useState } from "react";
import "../../css_files/Homepage/Sidebar.css";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { getCookie } from "../../api";

function Sidebar({
  setSidebarWidth,
  sidebaranotherRef,
  showtext,
  setshowtext,
  mobileMode,
  setRightSide,
  setLeftSide,
}) {
  const nav = useNavigate();
  const [isMasterOpen, setIsMasterOpen] = useState(false);
  const [isOperaionsOpen, setIsOperationsOpen] = useState(false);
  const [isTechnicianOpen, setIsTechnicianOpen] = useState(false);
  const [pinned, setpinned] = useState(false);
  const sidebarRef = useRef();
  const [refresh, setRefresh] = useState(false);

  function expandSidebar() {
    setRefresh(!refresh);
    setshowtext(true);
  }

  function shrinkSidebar() {
    setRefresh(!refresh);
    if (pinned === false && mobileMode === false) {
      setshowtext(false);
    }
  }

  const masterItems = [
    {
      path: "master/category-master",
      icon: "fa-solid fa-tags",
      label: "Category",
    },
    {
      path: "master/sub-category-master",
      icon: "fa-solid fa-sitemap",
      label: "Sub-Category",
    },
    {
      path: "master/hsn-master",
      icon: "fa-solid fa-code",
      label: "HSN",
    },
    {
      path: "master/unit-master",
      icon: "fa-solid fa-ruler",
      label: "Unit",
    },
    {
      path: "master/packing-master",
      icon: "fa-solid fa-box",
      label: "Packing",
    },
    {
      path: "master/currency-master",
      icon: "fa-solid fa-dollar-sign",
      label: "Currency",
    },
    {
      path: "master/gst-master",
      icon: "fa-solid fa-file-invoice",
      label: "GST",
    },
    {
      path: "master/parts-master",
      icon: "fa-solid fa-cogs",
      label: "Parts",
    },
    {
      path: "master/boiler-master",
      icon: "fa-solid fa-fire",
      label: "Boiler",
    },
    {
      path: "master/boiler-series-master",
      icon: "fa-solid fa-file-invoice",
      label: "Boiler Series",
    },
    {
      path: "master/boiler-series-parts-mapping-master",
      icon: "fa-solid fa-map",
      label: "Boiler Series Mapping",
    },
    {
      path: "master/courier-master",
      icon: "fa-solid fa-truck",
      label: "Courier",
    },
    {
      path: "master/customer-master",
      icon: "fa-solid fa-users",
      label: "Customer",
    },
    {
      path: "master/customer-pricing-master",
      icon: "fa-solid fa-money-bill",
      label: "Customer Pricing",
    },
    {
      path: "master/technician-master",
      icon: "fa-solid fa-tools",
      label: "Technician",
    },
    {
      path: "master/kilometer-rate",
      icon: "fa-solid fa-road",
      label: "Kilometre Rate",
    },
    {
      path: "master/service-report-master",
      icon: "fa-solid fa-tools",
      label: "Service Report",
    },
    {
      path: "master/service-report-mapping",
      icon: "fa-solid fa-tools",
      label: "Service Report Mapping",
    },
  ];

  const operationItems = [
    {
      path: "enquiries",
      icon: "fa-solid fa-book",
      label: "Enquiry",
    },
    {
      path: "tickets",
      icon: "fa-solid fa-ticket",
      label: "Tickets",
    },
    {
      path: "quotations",
      icon: "fa-solid fa-file-invoice-dollar",
      label: "Quotation",
    },
    {
      path: "orders",
      icon: "fa-solid fa-box",
      label: "Orders",
    },
    {
      path: "invoices",
      icon: "fa-solid fa-clipboard",
      label: "Invoice",
    },
  ];

  const technicianItems = [
    {
      path: "technician/vouchers",
      icon: "fa-solid fa-ticket",
      label: "Voucher",
    },
    {
      path: "technician/reports",
      icon: "fa-solid fa-file-lines",
      label: "Report",
    },
    {
      path: "technician/locations",
      icon: "fa-solid fa-location",
      label: "location",
    },
    {
      path: "technician/sitecontact",
      icon: "fa-solid fa-person-digging",
      label: "Site Contact",
    },
    {
      path: "technician/technicians",
      icon: "fa-solid fa-users-gear",
      label: "Technicians",
    },
  ];

  useEffect(() => {
    if (sidebarRef.current) {
      setSidebarWidth(sidebarRef.current.clientWidth);
    }
  }, [refresh]);

  return (
    <section
      className="sidebar"
      onMouseEnter={expandSidebar}
      onMouseLeave={shrinkSidebar}
      ref={(el) => {
        sidebarRef.current = el;
        sidebaranotherRef.current = el;
      }}
    >
      <div>
        {showtext && (
          <aside className="sidebar-item">
            <blockquote
              onClick={() => {
                expandSidebar();
                setpinned(!pinned);
              }}
            >
              <i
                class={`fa-solid ${
                  pinned ? "fa-thumbtack-slash" : "fa-thumbtack"
                }`}
              ></i>
              <span>{pinned ? "Unpin" : "Pin"}</span>
            </blockquote>
          </aside>
        )}
        <aside
          className="sidebar-item"
          onClick={() => {
            nav("/dashboard");
            if (mobileMode) {
              sidebaranotherRef.current.style.display = "none";
              setLeftSide(false);
            }
          }}
          title="Dashboard"
        >
          <blockquote>
            <i className="fa-solid fa-chart-pie"></i>
            <span>{showtext && "Dashboard"}</span>
          </blockquote>
        </aside>
        <aside
          className="sidebar-item"
          title="Enquiries"
          onClick={() => setIsOperationsOpen(!isOperaionsOpen)}
        >
          <blockquote>
            <i
              class={`fa-solid ${isOperaionsOpen ? "fa-book-open" : "fa-book"}`}
            ></i>
            <span>{showtext && "Operations"}</span>
          </blockquote>
        </aside>

        {isOperaionsOpen && (
          <>
            {operationItems.map((item, index) => (
              <aside
                key={index}
                className="dropdown-item"
                onClick={() => {
                  nav(item.path);
                  if (mobileMode) {
                    sidebaranotherRef.current.style.display = "none";
                    setLeftSide(false);
                  }
                }}
                title={item.label}
              >
                <blockquote>
                  <i className={item.icon}></i>
                  <span>{showtext && item.label}</span>
                </blockquote>
              </aside>
            ))}
          </>
        )}

        <aside
          className="sidebar-item"
          onClick={() => {
            setIsMasterOpen(!isMasterOpen);
          }}
          title="Master"
        >
          <blockquote>
            <i
              className={`fa-solid ${
                isMasterOpen ? "fa-folder-open" : "fa-folder"
              }`}
            ></i>
            <span>{showtext && "Master"}</span>
          </blockquote>
        </aside>

        {isMasterOpen && (
          <>
            {masterItems.map((item, index) => (
              <aside
                key={index}
                className="dropdown-item"
                onClick={() => {
                  nav(item.path);
                  if (mobileMode) {
                    sidebaranotherRef.current.style.display = "none";
                    setLeftSide(false);
                  }
                }}
                title={item.label}
              >
                <blockquote>
                  <i className={item.icon}></i>
                  <span>{showtext && item.label}</span>
                </blockquote>
              </aside>
            ))}
          </>
        )}

        <aside
          className="sidebar-item"
          onClick={() => {
            setIsTechnicianOpen(!isTechnicianOpen);
          }}
          title="Master"
        >
          <blockquote>
            <i
              className={`fa-solid ${
                isTechnicianOpen ? "fa-folder-open" : "fa-folder"
              }`}
            ></i>
            <span>{showtext && "Manage Technicians"}</span>
          </blockquote>
        </aside>

        {isTechnicianOpen && (
          <>
            {technicianItems.map((item, index) => (
              <aside
                key={index}
                className="dropdown-item"
                onClick={() => {
                  nav(item.path);
                  if (mobileMode) {
                    sidebaranotherRef.current.style.display = "none";
                    setLeftSide(false);
                  }
                }}
                title={item.label}
              >
                <blockquote>
                  <i className={item.icon}></i>
                  <span>{showtext && item.label}</span>
                </blockquote>
              </aside>
            ))}
          </>
        )}

        <aside className="sidebar-item" title="Settings">
          <blockquote>
            <i className="fa-solid fa-cog"></i>
            <span>{showtext && "Settings"}</span>
          </blockquote>
        </aside>
      </div>
    </section>
  );
}

export default Sidebar;
